export type LinkifySegment =
  | { type: 'text', value: string }
  | { type: 'link', value: string, href: string }

const URL_REGEX = /(https?:\/\/[^\s]+)/g
const TRAILING_PUNCTUATION = /[)\].,;:!?'"]+$/

export const linkify = (text: string): LinkifySegment[] => {
  if (!text) return []

  const segments: LinkifySegment[] = []
  let cursor = 0

  for (const match of text.matchAll(URL_REGEX)) {
    const rawUrl = match[0]
    const start = match.index ?? 0

    const trailing = rawUrl.match(TRAILING_PUNCTUATION)
    const url = trailing ? rawUrl.slice(0, -trailing[0].length) : rawUrl
    const end = start + url.length

    if (start > cursor) {
      segments.push({ type: 'text', value: text.slice(cursor, start) })
    }
    segments.push({ type: 'link', value: url, href: url })
    cursor = end
  }

  if (cursor < text.length) {
    segments.push({ type: 'text', value: text.slice(cursor) })
  }

  return segments
}